<div class="dialog-container">
  <h2 mat-dialog-title>
    <mat-icon>{{data.isEdit ? 'edit' : 'add'}}</mat-icon>
    {{data.isEdit ? 'Edit Option' : 'Create New Option'}}
  </h2>

  <mat-dialog-content>
    <div class="form-fields">
      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <input matInput [(ngModel)]="formData.title" placeholder="Enter option title" required>
      </mat-form-field>
      
      <mat-form-field appearance="outline">
        <mat-label>Image URL</mat-label>
        <input matInput [(ngModel)]="formData.image_url" placeholder="Enter image URL">
      </mat-form-field>
      
      <mat-form-field appearance="outline">
        <mat-label>Display Order</mat-label>
        <input matInput type="number" [(ngModel)]="formData.display_order" placeholder="Display order">
      </mat-form-field>
      
      <div class="checkbox-container">
        <mat-checkbox [(ngModel)]="formData.is_active">
          Active
        </mat-checkbox>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="!formData.title.trim()">
      <mat-icon>{{data.isEdit ? 'save' : 'add'}}</mat-icon>
      {{data.isEdit ? 'Update' : 'Create'}}
    </button>
  </mat-dialog-actions>
</div>
